export class Feedback {
  pk?: number;
  id?: number;
  name?: string;
  email?: string;
  message?: string;
}